import { Modal } from 'office-ui-fabric-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { hearingTypeByHearingIdSelector } from '../../../../../features/apiFeatures/hearingTypeSlice';
import { subjectAreaByHearingIdSelector } from '../../../../../features/apiFeatures/subjectAreaSlice';
import { fieldDataWithDiffsSelector } from '../../../../../features/componentFeatures/renderHearingSlice';
import {
  getAttr,
  getEntityId,
} from '../../../../../features/helpers/apiHelpers';
import { HearingInfoBox } from '../../HearingInfoBox';
import { RenderHearing } from '../../RenderHearing';
import { ImageWithMenu } from '../../ImageWithMenu';
import { FIELDTYPE_IMAGE, FIELDTYPE_TITLE } from '../../../../../constants/api';

const CreateHearingPreview = ({
  hearing,
  showPreview,
  onClosePreview,
  closeButtonLabel,
}) => {
  const subjectArea = useSelector(
    subjectAreaByHearingIdSelector(getEntityId(hearing)),
  );
  const hearingType = useSelector(
    hearingTypeByHearingIdSelector(getEntityId(hearing)),
  );

  const hearingId = getEntityId(hearing);
  const fieldsWithDiffs = useSelector(fieldDataWithDiffsSelector(hearingId));

  const titleField = fieldsWithDiffs.find(
    (field) => field.type === FIELDTYPE_TITLE,
  );
  const imageField = fieldsWithDiffs.find(
    (field) => field.type === FIELDTYPE_IMAGE,
  );

  const [titleContent] = titleField ? titleField.textContent : [];
  const [imageFileContent] = imageField ? imageField.fileContent : [];
  const [imageAltText] = imageField ? imageField.textContent : [];
  return (
    <div className="global-message">
      <Modal
        isOpen={showPreview}
        onDismiss={onClosePreview}
        styles={modalStyles}
      >
        <div className="modal-close-button">
          <IconButton
            iconProps={{ iconName: 'Cancel' }}
            ariaLabel={closeButtonLabel}
            onClick={onClosePreview}
          />
        </div>
        <div>
          <ImageWithMenu
            title={getAttr(titleContent, 'textContent')}
            imageUrl={getAttr(imageFileContent, 'urlToDownload')}
            imageAltText={getAttr(imageAltText, 'textContent')}
            hearingTypeName={getAttr(hearingType, 'name')}
            subjectAreaName={getAttr(subjectArea, 'name')}
            disableNavigationMenu={true}
          />
          <div className="modal-outer">
            <div className="create-hearing-write">
              <div style={renderHearingStyles}>
                <RenderHearing
                  hearing={hearing}
                  isEditMode={false}
                  disabledFieldTypes={FIELDTYPE_TITLE}
                  disableStateInitialization={true}
                />
              </div>
              <div>
                <HearingInfoBox hearing={hearing} disableTitle />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export { CreateHearingPreview };

const renderHearingStyles = {
  marginRight: '10px',
  width: '70%',
};

const modalStyles = {
  main: {
    width: '70vw',
    minWidth: '1200px',
    maxWidth: '1400px',
  },
  scrollableContent: {
    overflowY: 'unset',
  },
};
